import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ICancelExtractCreationParams extends IMultipleIdsParams {
  contentType: string;
}

export class CancelExtractCreationRequest extends Request<ICancelExtractCreationParams, IResult> {
  constructor(contentIds: string[], contentType: string) {
    super('cancelExtractCreation', {
      ids: contentIds,
      contentType: contentType
    });
  }
}
